export default __webpack_public_path__ + "static/media/logo-cdi.8e87136f.png";